import * as React from 'react';
import { VirtualTourJsonType, BasicContact } from '@bb/domain/dist/types';
import VtStep2SelectTour from './VtStep2SelectTour';
import VtStep3InviteGuests from './VtStep3InviteGuests';

interface VtAppointmentBookingProps {
  coop: BasicContact;
  currentStep: number;
  updateState: any;
  listingId: string;
  selectedTour: VirtualTourJsonType;
  dashboardId?: string;
  retsId?: string;
}

const VtAppointmentBooking: React.FC<VtAppointmentBookingProps> = ({
  coop,
  currentStep,
  updateState,
  listingId,
  selectedTour,
  dashboardId,
  retsId,
}) => (
    <>
      <VtStep2SelectTour
        coop={coop}
        currentStep={currentStep}
        listingId={listingId}
        updateState={updateState}
        dashboardId={dashboardId}
        retsId={retsId}
      />
      <VtStep3InviteGuests
        currentStep={currentStep}
        updateState={updateState}
        selectedTour={selectedTour}
      />
    </>
  );

export default VtAppointmentBooking;
